<template lang="pug">
div
    div(v-if="allowedRoles.includes(login_user.role)")
        div(v-if="isLoading")
            p Loading...
        div(v-else)
            div.d-flex.justify-content-between
                h1 <b>{{client.new_name.endsWith("s") ? client.new_name+"'" : client.new_name+"'s"}} Application Form</b>
                b-button.mb-4(onclick="window.print()" variant="primary")
                    b-icon.mr-2(icon="printer")
                    | Print
            b-card.border-0
                ApplicationFormPrint(:intakeAssessment="intakeAssessment" :client="client")
                b-button.mt-4(onclick="window.print()" variant="primary")
                    b-icon.mr-2(icon="printer")
                    | Print
    div(v-else)
        p.my-4 You're not allowed to view this page as {{login_user.role.replace(/_/g, ' ')}}
</template>
<script>
import ApplicationFormPrint from '@/components/intake_assessment/applicationFormPrint.vue';

export default {
    name: 'IntakeApplicationForm',
    components: {
        ApplicationFormPrint
    },
    data(){
        return{
            isLoading: true,
            allowedRoles:['admin', 'case_manager', 'case_manager_supervisor', 'team_lead', 'management','central_triage_team'],
        }
    },
    computed: {
        login_user(){
            return this.$store.state.login_user;
        },
        intakeAssessment(){
            return this.$store.state.intake_assessment;
        },
        client(){
            if(this.intakeAssessment?.new_IntakeClient_IntakeAssessment_new_Int && this.intakeAssessment.new_IntakeClient_IntakeAssessment_new_Int.length > 0) {
                return this.$store.state.intake_client;
            }
            return this.$store.state.client;
        }
    },
    mounted() {
        this.getIntakeAssessment();
    },
    methods: {
        async getIntakeAssessment() {
            await this.$store.dispatch('getIntakeAssessment', this.$route.params.intake_id).then(()=>{
                this.getClient();
            }).catch(()=>{
                // do something
            })
        },
        async getClient() {
            let actionName = 'getIntakeClient';
            let clientId = this.intakeAssessment.new_IntakeClient_IntakeAssessment_new_Int.length ? this.intakeAssessment.new_IntakeClient_IntakeAssessment_new_Int[0].new_intakeclientid : null;

            // If intakeclient obj not exist, load client profile
            if(!clientId) {
                actionName = 'getClient';
                clientId = this.intakeAssessment._new_client_value;
            }
            await this.$store.dispatch(actionName, clientId).then(()=>{
                this.isLoading = false;
            }).catch((err)=>{
                window.alert(err?.response?.data?.error || 'Something when wrong when retrieving client data!');
            });
        },
        
    }
}
</script>

<style lang="scss">

</style>